<template>
    <div class="vc_row wpb_row vc_row-fluid">
        <form>
            <div class="wpb_column vc_column_container vc_col-sm-6">
                <div class="vc_column-inner ">
                    <div class="wpb_wrapper">
                        <ul class="list-inline">
                            <li class="list-inline-item w-75"><input type="text" class="form-control"
                                                                     placeholder="¿Qué estás buscando?" v-model="buscador.texto"></li>
                            <li class="list-inline-item w-25">
                                <button type="button" class="btn btn-primary" @click="clickBuscar2">Buscar</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="wpb_column vc_column_container vc_col-sm-6">
                <div class="vc_column-inner ">
<!--                    <div class="wpb_wrapper">-->
<!--                        //espacio para nube de etiquetas-->
<!--                    </div>-->
                    <nube-etiquetas @click="clickNubeEtiquetas"></nube-etiquetas>
                </div>
            </div>
            <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="vc_column-inner ">
                    <div class="wpb_wrapper">
                        <span id="buscadorA" style="display: inline" class="easy_toggle" :class="{ 'toggle-active': buscador.buscadorAvanzado }" @click="clickBusquedaAvanzada"><i class="t-ico"></i>Búsqueda avanzada</span>
                        <div class="vc_row wpb_row vc_row-fluid" v-if="buscador.buscadorAvanzado">
                            <div class="wpb_column vc_column_container vc_col-sm-4">
                                <div class="vc_column-inner ">
                                    <div class="wpb_wrapper">
                                        <div class="form-group">
                                            <treeselect :multiple="true" :options="buscador.buscadorData.organos" placeholder="Órgano" v-model="buscador.organo"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="wpb_column vc_column_container vc_col-sm-4">
                                <div class="vc_column-inner ">
                                    <div class="wpb_wrapper">
                                        <div class="form-group">
                                            <treeselect :multiple="true" :options="buscador.buscadorData.localizaciones" placeholder="Localización" v-model="buscador.localizacion"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="wpb_column vc_column_container vc_col-sm-4">
                                <div class="vc_column-inner ">
                                    <div class="wpb_wrapper">
                                        <div class="form-group">
                                            <treeselect :multiple="true" :options="buscador.buscadorData.fases" placeholder="Fase" v-model="buscador.fase"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vc_row wpb_row vc_row-fluid" v-if="buscador.buscadorAvanzado">
                            <div class="wpb_column vc_column_container vc_col-sm-8">
                                <div class="vc_column-inner ">
                                    <div class="wpb_wrapper">
                                        <div class="form-group">
                                            <treeselect :multiple="true" :options="buscador.buscadorData.jurisdicciones" placeholder="Jurisdicción" v-model="buscador.jurisdiccion"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="wpb_column vc_column_container vc_col-sm-4">
                                <div class="vc_column-inner ">
                                    <div class="wpb_wrapper">
                                        <div class="form-group">
                                            <treeselect :multiple="false" :options="buscador.buscadorData.fuentes" placeholder="Fuente" v-model="buscador.fuente"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vc_row wpb_row vc_row-fluid" v-if="buscador.buscadorAvanzado">
                            <div class="wpb_column vc_column_container vc_col-sm-12">
                                <div class="vc_column-inner ">
                                    <div class="wpb_wrapper">
                                        <div class="form-group">
                                            <button type="button" class="btn btn-primary" @click="clickBuscar2">Filtrar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import axios from 'axios';
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import NubeEtiquetas from '../components/NubeEtiquetas';

    const WS_URL='https://admin.fundacionmarianoruizfunes.com/api/ws/criterio';
    // const WS_URL='http://fmrf2.local/api/ws/criterio';
    let headers = {
        'Content-Type': 'application/json'
    };

    export default {
        name: "Buscador",
        components: { Treeselect, NubeEtiquetas },
        data() {
            return {
                seed: 0,
                timer: null,
                contador: 0
            }
        },
        computed: mapState(['buscador']),
        methods: {
            leerBuscadorAvanzado() {
                axios
                    .post(WS_URL, {
                        "operacion": "getBuscador"
                    }, {"headers": headers})
                    .then(response => {
                        this.buscador.buscadorData = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            clickBusquedaAvanzada(){
                this.buscador.buscadorAvanzado=!this.buscador.buscadorAvanzado;
            },
            clickBuscar(page){
                //Si ya estoy en /listado no hay que navegar
                if(this.$router.currentRoute.name!='listado')
                    this.$router.push('listado');

                if(this.buscador.etiquetas.length>0){
                    axios
                        .post(WS_URL, {
                            "operacion": "getCriterios",
                            "page": (page==null ? 1 : page),
                            "filter": {
                                etiquetas: this.buscador.etiquetas
                            },
                            "order": [
                                {
                                    "campo": "id",
                                    "direccion": "desc"
                                }
                            ]
                        }, {"headers": headers})
                        .then(response => {
                            this.buscador.criterios = response.data;
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
                else{
                    axios
                        .post(WS_URL, {
                            "operacion": "getCriterios",
                            "page": (page==null ? 1 : page),
                            "filter": {
                                texto: this.buscador.texto,
                                organo: this.buscador.organo,
                                localizacion: this.buscador.localizacion,
                                fase: this.buscador.fase,
                                jurisdiccion: this.buscador.jurisdiccion,
                                fuente: this.buscador.fuente
                            },
                            "order": [
                                {
                                    "campo": "id",
                                    "direccion": "desc"
                                }
                            ]
                        }, {"headers": headers})
                        .then(response => {
                            this.buscador.criterios = response.data;
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            },
            //Esto se hace así porque se requiere un solo método clickBuscar para la paginación
            clickBuscar2(){
                this.buscador.etiquetas=[];
                this.clickBuscar();
            },
            clickNubeEtiquetas(id){
                this.buscador.etiquetas=[id];
                this.clickBuscar();
            }
        },
        mounted() {
            //Entero entre 0 y 9999
            this.seed = Math.floor(Math.random() * 10000);
            this.leerBuscadorAvanzado();

            /* Esta función cambia el display de buscadorA si se cambia a none. Se ejectuta 5 segundos */
            this.timer=setInterval(() => {
                if(document.getElementById('buscadorA')==null) {
                    clearInterval(this.timer);
                    return;
                }
                if(document.getElementById('buscadorA').style.display=='none'){
                    document.getElementById('buscadorA').style.display='inline';
                    clearInterval(this.timer);
                }
                else{
                    this.contador++;
                }
                if(this.contador==50)
                    clearInterval(this.timer);
            }, 100);
        }
    }
</script>

<style>
    .vue-treeselect__input{
        border: none !important;
        padding-left: 0px !important;
    }
</style>